// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__IgbdL","row":"Option_row__2P-vd"};